import { Component, EventEmitter, Output } from '@angular/core';

/**
 * component is shown, when user is connected to given scope server
 * show button to go to {@link RuntimeListComponent}
 */
@Component( {
    selector: 'app-start-scope',
    templateUrl: './start-scope.component.html',
    styleUrls: ['./start-scope.component.scss'],
    standalone: false
} )
export class StartScopeComponent {
    /** event emitter, broadcast, if download has been done or canceled */
    @Output() hasDownloadChange = new EventEmitter();

    /** event emitter, broadcast, when runtime has been downloaded */
    @Output() hasRuntimeChange = new EventEmitter();
}
